import { ArrowUpRight, Binoculars } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useUser } from '@r/api/auth.tsx';
import { getActiveWorkspaceUniversal } from '@r/helpers/api.ts';
import { isAdminOrHigher, type Role } from '@r/utils/roles.ts';

import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@ui/sidebar.tsx';

interface WorkspaceClientLinkProps {
  domain?: string;
}

export function WorkspaceClientLink({ domain }: WorkspaceClientLinkProps) {
  const { t } = useTranslation();
  const user = useUser();
  const activeWorkspace = getActiveWorkspaceUniversal(user.data?.visibleWorkspaces ?? []);

  if (!domain) return null;
  if (!isAdminOrHigher(activeWorkspace?.maxRole as Role)) return null;

  const url =
    domain.startsWith('http://') || domain.startsWith('https://') ? domain : `https://${domain}`;

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton asChild variant="outline">
          <a href={url} target="_blank" rel="noopener noreferrer">
            <Binoculars />
            <span>{t('menu.admin.workspace.participant')}</span>
            <ArrowUpRight className="ml-auto" />
          </a>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
